/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactsSectionGeneratedContactsInner } from './ContactsSectionGeneratedContactsInner';
import {
    ContactsSectionGeneratedContactsInnerFromJSON,
    ContactsSectionGeneratedContactsInnerFromJSONTyped,
    ContactsSectionGeneratedContactsInnerToJSON,
} from './ContactsSectionGeneratedContactsInner';

/**
 * 
 * @export
 * @interface ContactsSectionGenerated
 */
export interface ContactsSectionGenerated {
    /**
     * 
     * @type {Array<ContactsSectionGeneratedContactsInner>}
     * @memberof ContactsSectionGenerated
     */
    contacts: Array<ContactsSectionGeneratedContactsInner>;
    /**
     * 
     * @type {string}
     * @memberof ContactsSectionGenerated
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactsSectionGenerated
     */
    description?: string;
}

/**
 * Check if a given object implements the ContactsSectionGenerated interface.
 */
export function instanceOfContactsSectionGenerated(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contacts" in value;

    return isInstance;
}

export function ContactsSectionGeneratedFromJSON(json: any): ContactsSectionGenerated {
    return ContactsSectionGeneratedFromJSONTyped(json, false);
}

export function ContactsSectionGeneratedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactsSectionGenerated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contacts': ((json['contacts'] as Array<any>).map(ContactsSectionGeneratedContactsInnerFromJSON)),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function ContactsSectionGeneratedToJSON(value?: ContactsSectionGenerated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contacts': ((value.contacts as Array<any>).map(ContactsSectionGeneratedContactsInnerToJSON)),
        'title': value.title,
        'description': value.description,
    };
}

